var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10737",
    "data-name": "Group 10737",
    transform: "translate(-488 -8670)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4081",
    "data-name": "Rectangle 4081",
    width: 50,
    height: 50,
    transform: "translate(488 8670)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44701",
    "data-name": "Path 44701",
    d: "M31.2,4A5.242,5.242,0,0,1,36.61,9.058V25.245A5.242,5.242,0,0,1,31.2,30.3H7.408A5.242,5.242,0,0,1,2,25.245V9.058A5.242,5.242,0,0,1,7.408,4Zm3.245,8.014L19.855,20.047a1.148,1.148,0,0,1-.922.077l-.177-.077L4.163,12.018V25.245A3.145,3.145,0,0,0,7.408,28.28H31.2a3.145,3.145,0,0,0,3.245-3.035ZM31.2,6.023H7.408A3.145,3.145,0,0,0,4.163,9.058v.611L19.305,18,34.447,9.665V9.058A3.145,3.145,0,0,0,31.2,6.023",
    transform: "translate(494 8678)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.62486a16ca6089b77786fa865b8ec3b9.svg";
export { ForwardRef as ReactComponent };